import React from "react";

const AuthStateContext = React.createContext();

export default AuthStateContext;